$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Header scripts
  $('header .mobile-nav-toggle').append('<div></div><div></div><div></div>');

  // Searchbox scripts
  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', 'Search Website');

  $('.mobile-menu-container .search-container input').val('');
  $('.mobile-menu-container .search-container input').attr('placeholder', 'Search Website');

  // Countdown scripts
  $(window).load(function () {
    setTimeout(() => {
      const checkBody =
        $('body').hasClass('siteInfoBannerWidgetDateIsPast') ||
        $('body').hasClass('siteInfoBannerWidgetEventHappening');

      if (!checkBody) {
        $('#siteInfoBannerWidget #eventName .dayWord').remove();

        const countdownDays = $('#siteInfoBannerWidget #eventName .countdownDays').text();
        $('#siteInfoBannerWidget #eventName .countdownDays').remove();
        const countdownEventName = $('#siteInfoBannerWidget #eventName').text();

        $('#siteInfoBannerWidget #eventName').text(
          `Only ${countdownDays}days until ${countdownEventName}`,
        );
        $('.header .countdown-container').css('opacity', 1);
        $('#siteInfoBannerWidget').css('opacity', 1);
      } else {
        $('.header .countdown-container').css('opacity', 1);
        $('#siteInfoBannerWidget').css('opacity', 1);
      }
    }, 2000);
  });
  //sponsors heading replacement
  $(window).load(function () {
    const sponsorsTitle = $('.homepageh1').text();
    $('.homepageh1').replaceWith(`<h2 class="homepageh1">${sponsorsTitle}</h2>`);
  });
  // footer script
  $('.footer .socialNetworks').clone().appendTo('.footer #social-cloned');
});
